module.exports = __webpack_public_path__ + "img/live.7ed60dd.svg";